export enum ESelectButtonTheme {
  /** filled background with `$c-accent-2` and white arrow */
  default,
  /** transparent background and filled arrow with `$c-accent` */
  alt,
}
